"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputRange = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var InputRange = function (_a) {
    var onChange = _a.onChange, inputClassname = _a.inputClassname, className = _a.className, min = _a.min, max = _a.max, withScale = _a.withScale, unused = __rest(_a, ["onChange", "inputClassname", "className", "min", "max", "withScale"]);
    var scale = [];
    if (withScale && typeof min !== 'undefined' && typeof max !== 'undefined') {
        var scaleUnit = Number(min);
        do {
            scale.push(scaleUnit);
            scaleUnit++;
        } while (scaleUnit < Number(max) + 1);
    }
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)(className) },
        scale.length !== 0 && (react_1.default.createElement("div", { className: (0, classnames_1.default)('br-flex', 'br-justify-between', 'br--mx-2') }, scale.map(function (unit) { return (react_1.default.createElement("div", { className: (0, classnames_1.default)('br-w-8', 'br-text-center'), key: unit }, unit)); }))),
        react_1.default.createElement("input", __assign({ onChange: function (event) {
                var target = event.target;
                onChange === null || onChange === void 0 ? void 0 : onChange(target.value);
            }, type: "range", className: (0, classnames_1.default)('br-w-full', 'br-rounded-default', inputClassname), min: min, max: max }, unused))));
};
exports.InputRange = InputRange;
